require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ru-pages-general-contractor.json") })
        }
      }, "path---ru-pages-general-contractor");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ru-pages-general-contractor!./.cache/json/ru-pages-general-contractor.json
// module id = 773
// module chunks = 231608221292675